import { CrumbInterface } from 'src/app/services/navigation/navigation.interface';

type BreadcrumbKey =
  | 'Home'
  | 'ManageMasterWagesDetermination'
  | 'ManageMasterWagesCrafts'
  | 'ManageProjectWages';

export const Breadcrumb: Record<BreadcrumbKey, CrumbInterface> = {
  Home: { id: 'crumb-home', pathName: '/', label: 'Home', queryParams: '' },
  ManageMasterWagesDetermination: {
    id: 'crumb-manage-master-wage-data',
    pathName: '/setup/prevailing-wage-setup/manage-master-wage-data',
    label: 'Manage Master Wages',
  },
  ManageMasterWagesCrafts: {
    id: 'crumb-manage-master-wage-data',
    pathName:
      '/setup/prevailing-wage-setup/manage-master-wage-data/manage-classification-rates',
    label: 'Manage Master Wages',
  },
  ManageProjectWages: {
    id: 'crumb-manage-project-wage-data',
    pathName: '/setup/prevailing-wage-setup/manage-project-wage-data',
    label: 'Manage Project Wages',
  },
} as const;
